import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import cities from "./cities"; // same cities file use hogi
import CategorySlider from "../../../CategorySlider";

const Karnataka = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <div
        style={{
          marginTop: "90px",
          padding: "25px",
          backgroundColor: "#FFF5F5",
          minHeight: "90vh",
          lineHeight: "1.7"
        }}
      >
        <h1>Sex Toys Delivery in Karnataka</h1>

        <p>
          Buy premium <strong>sex toys in Karnataka</strong> with fast & discreet
          delivery. LushDesire offers genuine adult toys and couples wellness
          products with complete privacy across Karnataka.
        </p>

        <h2>Cities We Serve in Karnataka</h2>

        <ul>
          {cities.map((c) => (
            <li key={c.slug}>
              <Link to={`/sex-toys-delivery/karnataka/${c.slug}`}>
                Sex Toys in {c.city}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = cities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{ marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Karnataka
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city}, Karnataka with fast & discreet delivery. Premium adult toys & couples wellness products available.`}
        />
      </Helmet>
<CategorySlider />

      <div
        style={{
         
          padding: "25px",
          backgroundColor: "#FFF5F5",
          minHeight: "90vh",
          lineHeight: "1.7"
        }}
      >
        {/* H1 */}
        <h1>Sex Toys in {cityData.city} – Discreet Delivery in Karnataka</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          is a trusted Indian online store offering premium adult toys and
          couples wellness products with 100% discreet packaging.
        </p>

        {/* H2 */}
        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Shopping for sex toys online in {cityData.city} is now safe, private,
          and convenient. We deliver body-safe, high-quality pleasure products
          directly to your doorstep across Karnataka.
        </p>

        {/* H3 */}
        <h3>Popular Sex Toys Available in {cityData.city}</h3>
        <ul>
          <li>✔ Vibrators & Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Sex Toys</li>
          <li>✔ Male Masturbators</li>
          <li>✔ Female Pleasure & Wellness Products</li>
        </ul>

        {/* H3 */}
        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <p>
          Customers across Karnataka trust LushDesire for privacy, quality, and
          reliable service.
        </p>

        <ul>
          <li>✔ 100% Discreet & Plain Packaging</li>
          <li>✔ Fast Delivery in {cityData.city}</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Secure Online Payments</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        {/* H4 */}
        <h4>Discreet Sex Toys Delivery Across Karnataka</h4>
        <p>
          Whether you are in Bengaluru, Mysuru, Mangaluru, Hubli, or any other
          city, we ensure safe and confidential delivery with no adult branding
          on the package.
        </p>

        {/* H5 */}
        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Enhance your intimacy and wellness today. Order sex toys online in{" "}
          {cityData.city}, Karnataka and enjoy fast, private, and reliable
          delivery.
        </p>

        <p>
          <strong>LushDesire</strong> – India’s trusted destination for sex toys
          and couples wellness products.
        </p>
      </div>
    </>
  );
};

export default Karnataka;
